import { useState } from 'react'

import { EntityTabAttributes } from '../../../EntityTab'
import { Component, ComponentProps } from '../../Component'
import { controls, json, text } from '../../Controls'

import { PROFILE_ATTRIBUTES_INHABITANT_DATA } from './ProfileAttributesTabInhabitant.constants'

function ProfileAttributesTabInhabitant() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(text('title', 'Attributes'))
      .add(json('attributes', PROFILE_ATTRIBUTES_INHABITANT_DATA))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={EntityTabAttributes}
        name='EntityTabAttributes'
      />
      <ComponentProps
        name='EntityTabAttributes'
        value={props}
        onChange={setProps}
      />
    </>
  )
}

export default ProfileAttributesTabInhabitant
